import {inject} from "@angular/core";
import {CanActivateFn, Router} from "@angular/router";
import {AuthService} from "../services/auth.service";

/**
 * Shell guard, registered as both `canActivate` and `canActivateChild`
 * so it runs on EVERY navigation inside the shell, not only on entry.
 *
 * An access token that expired while the admin was idle is checked
 * here, before the page loads: refresh it silently, or — when the
 * refresh is refused or there is no refresh token (SSO sessions) —
 * clear the session and send the admin to /login with `next` set to
 * the page they clicked. Without this, the page loaded with a dead
 * token and its first API call failed on screen.
 */
export const authGuard: CanActivateFn = async (_route, state) => {
    const auth = inject(AuthService);
    const router = inject(Router);
    const toLogin = () => router.createUrlTree(["/login"], {queryParams: {next: state.url}});

    if (!auth.isAuthenticated()) {
        return toLogin();
    }
    if (!auth.isAccessExpired()) {
        return true;
    }
    if (await auth.refreshAccessToken()) {
        return true;
    }
    auth.clearToken();
    return toLogin();
};
